<template>
  <a-card :bordered="false" :bodyStyle="{ padding: '16px 0', height: '100%' }" :style="{ height: '100%' }">
    <div class="account-settings-info-view">
      <a-row :gutter="16" type="flex" justify="center">
        <a-col :md="24" :lg="16">
          <a-form-model :model="addOrUpdateForm" ref="addOrUpdateForm" :rules="rules">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区选择" prop="zoneId">
              <a-tree-select
                :tree-data="zoneTreeData"
                v-model="addOrUpdateForm.zoneId"
                style="width: 100%"
                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                placeholder="请选择片区"
                :treeDefaultExpandedKeys="treeDefaultExpandedKeys"
                show-search
                treeNodeFilterProp="title"
                @select="onSelect"
              ></a-tree-select>
            </a-form-model-item>
            <!-- <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="日期" prop="balanceYear">
              <a-date-picker style="width: 100%" placeholder="请选择年份" :allowClear="false" 
                v-model="addOrUpdateForm.balanceYear" format="YYYY" mode="year" :open="open" @openChange="openChange"
                @panelChange="panelChange" />
            </a-form-model-item> -->

            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="日期" prop="balanceYear">
              <a-radio-group :value="selectDay" @change="changeRadio" button-style="solid">
                <a-radio-button value="year">年份</a-radio-button>
                <a-radio-button value="quarter">季度</a-radio-button>
                <a-radio-button value="month">月份</a-radio-button>
                <a-radio-button value="other">其他</a-radio-button>
              </a-radio-group>

              <a-range-picker
                :placeholder="['开始日期', '截止日期']"
                :allowClear="false"
                v-model="addOrUpdateForm.balanceYear"
                :format="['YYYY-MM-DD', 'YYYY-MM-DD']"
                :valueFormat="'YYYY-MM-DD'"
                :mode="['date', 'date']"
                 v-if="selectDay == 'other'"
              />

              <a-date-picker
                v-else
                style="margin-left: 20px"
                placeholder="请选择日期"
                :allowClear="false"
                v-model="addOrUpdateForm.balanceYear"
                :format="selectFormat"
                :mode="selectMode"
                :open="open"
                @openChange="openChange"
                @panelChange="panelChange"
              />
              <a-select
                v-if="selectDay == 'quarter'"
                default-value="1"
                style="width: 120px; margin-left: 10px"
                v-model="queryQuarter"
              >
                <a-select-option value="第一季度">第一季度</a-select-option>
                <a-select-option value="第二季度">第二季度</a-select-option>
                <a-select-option value="第三季度">第三季度</a-select-option>
                <a-select-option value="第三季度">第四季度</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供水量(m³)" prop="waterSupply">
              <a-input placeholder="请输入供水量(m³)" v-model="addOrUpdateForm.waterSupply" />
            </a-form-model-item>

            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="收费已计量用水量(m³)"
              prop="chargeMeasured"
            >
              <a-input placeholder="请输入收费已计量用水量(m³)" v-model="addOrUpdateForm.chargeMeasured" />
            </a-form-model-item>

            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="收费未计量用水量(m³)"
              prop="chargeNotMeasured"
            >
              <a-input v-model="addOrUpdateForm.chargeNotMeasured" placeholder="请输入收费未计量用水量(m³)" />
            </a-form-model-item>

            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="未收费已计量用水量(m³)"
              prop="notChargeMeasured"
            >
              <a-input placeholder="请输入未收费已计量用水量(m³)" v-model="addOrUpdateForm.notChargeMeasured" />
            </a-form-model-item>

            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="未收费未计量用水量(m³)"
              prop="notChargeNotMeasured"
            >
              <a-input placeholder="请输入未收费未计量用水量(m³)" v-model="addOrUpdateForm.notChargeNotMeasured" />
            </a-form-model-item>

            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="非法用水量(m³)" prop="illegal">
              <a-input placeholder="请输入非法用水量(m³)" v-model="addOrUpdateForm.illegal" />
            </a-form-model-item>

            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="表计误差损失水量(m³)"
              prop="meterErrorLoss"
            >
              <a-input placeholder="请输入表计误差损失水量(m³)" v-model="addOrUpdateForm.meterErrorLoss" />
            </a-form-model-item>

            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="主干管漏失水量(m³)"
              prop="mainPipeLeakage"
            >
              <a-input placeholder="请输入主干管漏失水量(m³)" v-model="addOrUpdateForm.mainPipeLeakage" />
            </a-form-model-item>

            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="蓄水池漏失和溢流水量(m³)"
              prop="reservoirLeakage"
            >
              <a-input placeholder="请输入蓄水池漏失和溢流水量(m³)" v-model="addOrUpdateForm.reservoirLeakage" />
            </a-form-model-item>
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="支管段漏失水量(m³)"
              prop="branchPipeLeakage"
            >
              <a-input placeholder="请输入支管段漏失水量(m³)" v-model="addOrUpdateForm.branchPipeLeakage" />
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 200px" type="primary" :loading="confirmLoading" @click="updateData"
                >录入</a-button
              >
            </a-form-model-item>
          </a-form-model>
        </a-col>
      </a-row>
    </div>
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import { baseMixin } from '@/store/app-mixin'
import mixinViewModule from '@/mixin/commonModel'
import moment from 'moment'
function toMath(val) {
  if (val) {
    return parseFloat(parseFloat(val).toFixed(2))
  } else {
    return parseFloat(0)
  }
}

export default {
  mixins: [mixinViewModule],
  name: 'WaterBalance',
  components: {},
  data() {
    return {
      zoneTreeData: [], // 片区选项
      queryUrl: '/pipe-network/zone_water_balances/page', //查询刷新
      queryQuarter: '第一季度',
      municipalRate: '0.03',
      selectFormat: 'YYYY',
      selectMode: 'year',
      open: false,
      selectDay: 'year',
      record: {},
      confirmLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
      addOrUpdateForm: {
        balanceYear: '',
        zoneId: '',
        zoneName: '',
        waterSupply: '',
        chargeNotMeasured: '',
        notChargeMeasured: '',

        notChargeNotMeasured: '',
        chargeMeasured: '',
        illegal: '',
        meterErrorLoss: '',
        mainPipeLeakage: '',
        reservoirLeakage: '',
        branchPipeLeakage: '',
      },
      rules: {
        zoneId: [{ required: true, message: '请选择片区', trigger: 'change' }],
        // balanceYear: [{ required: true, message: '请选择日期', trigger: 'change' }],
        waterSupply: [
          { required: true, message: '请输入供水量' },
          { pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入最多两位小数数字' },
        ],
        chargeMeasured: [
          { required: true, message: '请输入收费已计量用水量' },
          { pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入最多两位小数数字' },
        ],
        // chargeNotMeasured: [
        //   { required: true, message: '请输入收费未计量用水量' },
        //   { pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入最多两位小数数字' },
        // ],
        // notChargeMeasured: [
        //   { required: true, message: '请输入未收费已计量用水量' },
        //   { pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入最多两位小数数字' },
        // ],
        // notChargeNotMeasured: [
        //   { required: true, message: '请输入未收费未计量用水量' },
        //   { pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入最多两位小数数字' },
        // ],
        // illegal: [
        //   { required: true, message: '请输入非法用水量' },
        //   { pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入最多两位小数数字' },
        // ],
        // meterErrorLoss: [
        //   { required: true, message: '请输入表计误差损失水量' },
        //   { pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入最多两位小数数字' },
        // ],
        // mainPipeLeakage: [
        //   { required: true, message: '请输入表计误差损失水量' },
        //   { pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入最多两位小数数字' },
        // ],
        // reservoirLeakage: [
        //   { required: true, message: '请输入蓄水池漏失和溢流水量' },
        //   { pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入最多两位小数数字' },
        // ],
        // branchPipeLeakage: [
        //   { required: true, message: '请输入支管段漏失水量' },
        //   { pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入最多两位小数数字' },
        // ],
      },
      addUrl: '/pipe-network/zone_water_balances',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      treeDefaultExpandedKeys: [], //默认展开的树节点
    }
  },
  watch: {
    zoneTreeData(val) {
      this.chuli(val)
    },
    selectDay(val) {
      if (val == 'other') {
        this.addOrUpdateForm.balanceYear = ['', '']
      } else {
        this.addOrUpdateForm.balanceYear = ''
      }
    },
  },
  methods: {
    onSelect(value, node, extra) {
      console.log(value, node, extra)
      this.addOrUpdateForm.zoneName = extra.node.title
      console.log(extra.node.title)
    },
    getZoneData() {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
 
    chuli(n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {
          item.children = this.chuli(item.children)

          if (item.level == 1) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },
    changeRadio(e) {
      this.selectDay = e.target.value
      if (this.selectDay == 'year') {
        this.selectFormat = 'YYYY'
        this.selectMode = 'year'
        // this.addOrUpdateForm.degreeType = 2
      } else if (this.selectDay == 'month') {
        this.selectFormat = 'YYYY-MM'
        this.selectMode = 'month'
        // this.addOrUpdateForm.degreeType = 0
      } else  if (this.selectDay == 'quarter'){
        this.selectFormat = 'YYYY'
        this.selectMode = 'year'
        // this.addOrUpdateForm.degreeType = 1
      }
    },
    panelChange(value) {
      this.addOrUpdateForm.balanceYear = value
      this.open = false
    },
    openChange(status) {
      if (status) {
        this.open = true
      } else {
        this.open = false
      }
    },
    //更新数据
    updateData() {
      if (!this.addOrUpdateForm.balanceYear) {
        this.$message.warning('请选择日期！')
        return
      }
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          // this.confirmLoading = true
          let params = this.addOrUpdateForm
          console.log(params.balanceYear)

          // typeof params.balanceYear === 'string' ? '' : (params.balanceYear = params.balanceYear.format('YYYY'))
          if (this.selectDay == 'year') {
            typeof params.balanceYear === 'string' ? '' : (params.balanceYear = params.balanceYear.format('YYYY'))
          } else if (this.selectDay == 'quarter') {
            typeof params.balanceYear === 'string'
              ? ''
              : (params.balanceYear = params.balanceYear.format('YYYY') + this.queryQuarter)
          } else if (this.selectDay == 'month') {
            typeof params.balanceYear === 'string' ? '' : (params.balanceYear = params.balanceYear.format('YYYY-MM'))
          } else if (this.selectDay == 'other') {
            console.log(typeof params.balanceYear)

            typeof params.balanceYear === 'object'
              ? (params.balanceYear = params.balanceYear[0] + '~' + params.balanceYear[1])
              : ''
          }
          console.log(params.balanceYear)
          this.$http
            .post(this.addUrl, params)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success(res.message)
                this.$refs.addOrUpdateForm.resetFields()
              } else {
                this.$message.warning(res.message)
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
        // this.query()
      })
    },
  },
  created() {
    this.getZoneData()
  },
}
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>
